import {Component, EventEmitter, Input, OnInit, Output, inject} from '@angular/core';
import {MfaUserDetails} from '../../_data/mfa/mfa-user-details';
import {MfaService} from '../../_services/data/mfa.service';
import {EnabledDeviceComponent} from '../enabled-device/enabled-device.component';
import {AddMfaDeviceComponent} from '../add-mfa-device/add-mfa-device.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-mfa-user-device-admin',
    templateUrl: './user-device-admin.component.html',
    styleUrls: ['./user-device-admin.component.scss'],
    imports: [EnabledDeviceComponent, AddMfaDeviceComponent, TranslateModule]
})
export class UserDeviceAdminComponent implements OnInit {

  @Input() userName: string;
  @Input() displayEnabledDevices = true;
  @Input() allowAddingDevice = true;
  @Input() getExistingMfaDevices = true;

  /**
   * Allows adding more devices if there is already one set up
   */
  @Input() allowAddingMultiple = true;

  /**
   * Allows the user to change which device is primary using buttons
   */
  @Input() allowChangingPrimary = true;

  /**
   * Allows the user to remove devices using buttons
   */
  @Input() allowRemovingDevice = true;

  @Output() mfaDevicesChanged = new EventEmitter<number>();

  mfaUserDetails: MfaUserDetails;
  addMfa: boolean;

  private mfaService = inject(MfaService);

  private loadMfa() {
    console.debug('Loading mfa device details...');
    this.mfaService.getUserMfaDetails(this.userName).subscribe((mfaUserDetails: MfaUserDetails) => {
      this.mfaUserDetails = mfaUserDetails;
      this.mfaDevicesChanged.emit(this.mfaUserDetails?.userDetails?.devicesDetails?.length ?? 0);
    });
  }

  ngOnInit(): void {
    if(this.getExistingMfaDevices) {
      this.loadMfa();
    }
  }

  devicesChanged() {
    console.info('MFA devices changed');
    this.addMfa = false;
    this.loadMfa();
  }

  get showAddDevice(): boolean {
    //The primary field for this is "allowAddingDevice"
    //However, even if that is set to true, if "allowAddingMultiple" is false and there's already at least one device, this method will return false
    const hideBecauseMultiple = !this.allowAddingMultiple && this.mfaUserDetails?.userDetails?.devicesDetails?.length >= 1;

    return this.allowAddingDevice && !hideBecauseMultiple;

  }

}
